// src/stone/illustrations/StonjiWheelIllustration.tsx
import { jsx, jsxs } from "react/jsx-runtime";
var StonjiWheelIllustration = (props) => /* @__PURE__ */ jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 80 80",
    ...props,
    children: [
      /* @__PURE__ */ jsx("path", { fill: "#20252A", d: "M0 0h80v80H0z" }),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#fff",
          d: "M40 15.003a2.502 2.502 0 1 0 0-5.004 2.502 2.502 0 0 0 0 5.004M40 70.001a2.502 2.502 0 1 0 0-5.003A2.502 2.502 0 0 0 40 70"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#fff",
          d: "M42.498 12.501h-5v54.998h5zM12.5 42.502a2.502 2.502 0 1 0 0-5.003 2.502 2.502 0 0 0 0 5.003M67.451 42.502a2.502 2.502 0 1 0 0-5.003 2.502 2.502 0 0 0 0 5.003"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#fff",
          d: "M12.5 37.498v5h54.95v-5zM20.568 61.93a2.502 2.502 0 1 0 0-5.004 2.502 2.502 0 0 0 0 5.003M59.375 23.123a2.502 2.502 0 1 0 0-5.004 2.502 2.502 0 0 0 0 5.004"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#fff",
          d: "m18.803 57.66 3.535 3.536 38.808-38.808-3.535-3.536zM59.4 61.903a2.502 2.502 0 1 0 0-5.004 2.502 2.502 0 0 0 0 5.004"
        }
      ),
      /* @__PURE__ */ jsx("path", { fill: "#fff", d: "m57.633 61.172 3.535-3.535-38.89-38.89-3.535 3.535z" }),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#00A868",
          d: "M40.005 10a30 30 0 1 0-.01 60 30 30 0 0 0 .01-60m0 49.999a20.017 20.017 0 1 1 0-40.033 20.017 20.017 0 0 1 0 40.033"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#00A868",
          d: "M40 50c5.523 0 10-4.477 10-10s-4.477-10-10-10-10 4.477-10 10 4.477 10 10 10"
        }
      ),
      /* @__PURE__ */ jsx("path", { fill: "#fff", d: "M40 45a5 5 0 1 0 0-10 5 5 0 0 0 0 10" })
    ]
  }
);
var StonjiWheelIllustration_default = StonjiWheelIllustration;

export {
  StonjiWheelIllustration_default
};
